import { localisedValue } from "utils"

const projectTransformer = response => {
  return response.map(e => {
    return {
      ...e,
      id: e.projectId,
      label: localisedValue({ object: e, key: "name" }),
      value: e.projectId.toString(),
      tokenWithUnit: e.minTokenUnit !== "amount" ? e.minToken / 100 : e.minToken,
      mortgageTokenWithUnit: e?.minTokenUnitMortgage !== "amount" ? e?.minTokenMortgage / 100 : e?.minTokenMortgage,
      pdpPercentage: e?.partialDp * 0.01,
      cdpPercentage: e?.ProjectFinancial?.completeDownPayment * 0.01,
    }
  })
}

export default projectTransformer
